import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Alert } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/LicenseVerificationPaymentSuccess.css";

const LicenseVerificationPaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [countdown, setCountdown] = useState(10);
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);

  const { 
    licenseData, 
    paymentDetails
  } = location.state || {};

  // API base URL
  const API_BASE_URL = process.env.REACT_APP_BASEURL || "http://localhost:4890";

  // Function to update user's license verification status
  const updateLicenseVerificationStatus = async () => {
    try {
      setIsUpdatingStatus(true);
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      
      if (!token || !user.details_id) {
        throw new Error("User authentication required");
      }

      const response = await fetch(`${API_BASE_URL}/update-license-verification-status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          userId: user.details_id,
          isLicenseVerificationDone: true
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log("License verification status updated:", result);
    } catch (error) {
      console.error("Error updating license verification status:", error);
      // Don't show error to user as payment was successful
    } finally {
      setIsUpdatingStatus(false);
    }
  };

  useEffect(() => {
    // Update license verification status when component mounts
    updateLicenseVerificationStatus();

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/license-verification-form');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}>

        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container license-verification-payment-success-content-container">
          <section className="license-verification-payment-success-section">
            <Container className="">
              <h2 className="text-center license-verification-payment-success-heading mb-4 pt-4">
                License Verification Payment Successful!
              </h2>

              <Row className="justify-content-center pb-5">
                <Col md={8}>
                  <Card className="p-4 shadow-sm license-verification-payment-success-card">
                    <div className="text-center">
                      <div className="success-icon mb-4">
                        <i className="fas fa-check-circle" style={{ fontSize: '64px', color: '#28a745' }}></i>
                      </div>
                      
                      <h3 className="mb-3">Thank You!</h3>
                      
                      <p className="mb-4">
                        Your license verification payment has been processed successfully.
                      </p>

                      {paymentDetails && (
                        <div className="payment-details mb-4">
                          <h5 className="text-success mb-3">
                            <i className="fas fa-receipt me-2"></i>
                            Payment Details
                          </h5>
                          <div className="payment-info p-3 bg-light rounded">
                            <p className="mb-2">
                              <strong>Order ID:</strong> {paymentDetails.orderId}
                            </p>
                            <p className="mb-2">
                              <strong>Payment ID:</strong> {paymentDetails.paymentId}
                            </p>
                            <p className="mb-0">
                              <strong>Amount Paid:</strong> ₹{paymentDetails.amountInRupees?.toFixed(2) || (paymentDetails.amount/100).toFixed(2)}
                            </p>
                          </div>
                        </div>
                      )}

                      {licenseData && (
                        <div className="license-details mb-4">
                          <h5 className="text-info mb-3">
                            <i className="fas fa-file-alt me-2"></i>
                            License Verification Details
                          </h5>
                          <div className="license-info p-3 bg-light rounded">
                            <p className="mb-2">
                              <strong>Authority Name:</strong> {licenseData.authorityName}
                            </p>
                            <p className="mb-2">
                              <strong>AIOTA Membership Number:</strong> {licenseData.aiotaMembershipNumber}
                            </p>
                            <p className="mb-2">
                              <strong>ACOT/IOTR Number:</strong> {licenseData.acotIotrNumber}
                            </p>
                            <p className="mb-0">
                              <strong>State Branch:</strong> {licenseData.stateBranchName}
                            </p>
                          </div>
                        </div>
                      )}

                      <Alert variant="success" className="mb-4">
                        <h6 className="mb-2">
                          <i className="fas fa-check-circle me-2"></i>
                          What happens next?
                        </h6>
                        <ul className="mb-0 small text-start d-flex flex-column justify-content-center">
                          <li>Your license verification request has been submitted</li>
                          <li>Payment has been processed successfully</li>
                          <li>Your request will be reviewed by the AIOTA team</li>
                          <li>You will receive confirmation via email once processing is complete</li>
                          <li>License verification certificate will be sent to your registered email</li>
                        </ul>
                      </Alert>

                      <Alert variant="info">
                        Redirecting to license verification form in {countdown} seconds...
                      </Alert>

                      <p className="mt-3">
                        For any queries regarding your license verification, please contact the AIOTA office.
                      </p>
                    </div>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default LicenseVerificationPaymentSuccess;
